import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'

import { ActionList } from 'components/ActionList'
import Box from 'components/Box'
import { Button, TYPE } from 'components/Button'
import { Col, Grid, GridGap } from 'components/Grid'
import Heading from 'components/Heading'
import Hero, { HeroType } from 'components/Hero/Hero'
import Icon from 'components/Icon'
import { InfoBox, InfoBoxItem } from 'components/InfoBox'
import { List, ListItem } from 'components/List'
import ListHeader from 'components/ListHeader'
import Section, { SectionType, Size } from 'components/Section/Section'
import Style from 'components/Style'
import { SRPRS } from 'Icon/srprs'
import NumberPeople from '../../elements/buttons/NumberPeople'
import Calendar from '../../elements/Calendar'
import FunnelFooter from '../../elements/footers/funnelFooter'
import FunnelBreadcrumbs from '../../elements/FunnelBreadcrumbs'
import GiftcardModal from '../../elements/modals/GiftcardModal'
import PersonModal from '../../elements/modals/PersonModal'
import Airport from '../funnel/customise/options/airport'
import Days from '../funnel/customise/options/days'
import FlyExcluded from '../funnel/customise/options/flyExcluded'
import RoomType from '../funnel/customise/options/roomType'
import { QueryKey } from '../funnel/customise/wrapper'

import { EntryProps } from '../../data/entries/types'
import { inControlOptions } from '../../data/models/funnelOrder/days'
import { Theme } from '../../data/models/funnelOrder/theme'
import { AppState } from '../../data/state'
import { FunnelStep } from '../../data/ui'
import { getNameWithTheme, getParamsWithTheme } from '../../routing/links'
import {
  CustomiseWrapperInnerProps,
  withAirportsAndPrices,
} from '../funnel/customise/wrapperFunction'
import Page from '../shared/page_wrapper'
import FAQ from './components/faq'
import FlavourBox from './components/flavourBox'
import HowItWorks from './components/howItWorks'

interface FlavourPageProps extends EntryProps {
  patternImage: string
  departureDate: Date | null
  total: number
  theme: Theme
}

class FlavourPage extends React.Component<
  FlavourPageProps & CustomiseWrapperInnerProps
> {
  private infoSection?: HTMLDivElement
  private detailsSection?: HTMLDivElement

  public componentDidMount() {
    window.scrollTo(0, 0)
  }

  public render() {
    const { entry, match, patternImage, airports, prices, loading } = this.props
    const date = this.props.departureDate

    if (entry.page === undefined) {
      throw new Error('No page properties')
    }

    return (
      <Page
        match={match}
        page={entry.page.name}
        color={entry.colour}
        navBarType="funnel"
        navBarOverrideColour={
          entry.page.style ? entry.page.style.navbarColor : undefined
        }
        navFooter
      >
        <Hero
          type={HeroType.flavourEntry}
          headingColor={
            entry.page.style ? entry.page.style.headingColor : undefined
          }
          headingText={
            <DisplayContent contentKey="title">{entry.name}</DisplayContent>
          }
          subHeading={<FunnelBreadcrumbs funnelStep={FunnelStep.Customise} />}
          src={entry.page.photos.src}
          src1024={entry.page.photos.src1024}
          src1280={entry.page.photos.src1280}
          src1600={entry.page.photos.src1600}
          src1920={entry.page.photos.src1920}
        >
          <FunnelBreadcrumbs funnelStep={FunnelStep.Customise} />
          <Heading level={1}>
            <DisplayContent contentKey="title">{entry.name}</DisplayContent>
          </Heading>
          <InfoBox>
            <InfoBoxItem
              icon={SRPRS.calendarMonth}
              firstLine={
                <DisplayContent contentKey="1-info-top">3 - 14</DisplayContent>
              }
              secondLine={
                <DisplayContent contentKey="1-info-bottom">
                  Dagen
                </DisplayContent>
              }
            />
            <InfoBoxItem
              icon={SRPRS.calendar(date ? new Date(date).getDate() : undefined)}
              firstLine={
                <DisplayContent contentKey="2-info-top">2 tot 4</DisplayContent>
              }
              secondLine={
                <DisplayContent contentKey="2-info-bottom">
                  Steden
                </DisplayContent>
              }
            />
            <InfoBoxItem
              icon={SRPRS.mapMarker}
              firstLine={
                <DisplayContent contentKey="3-info-top">Heel</DisplayContent>
              }
              secondLine={
                <DisplayContent contentKey="3-info-bottom">
                  Europa
                </DisplayContent>
              }
            />
          </InfoBox>
        </Hero>
        <Section type={SectionType.solid} size={Size.xs} noPadding>
          <Style margin={[[20, 0, 20, 0]]}>
            <DisplayContent addNode contentKey="blurb">
              For you one city is not enough. Get lost in the labyrinth known as
              Europe. Stil discover where you're going at the airport. Every
              city is in another country. Experience the different flavours on
              offer.
            </DisplayContent>
          </Style>
          <Style margin={[[0, 0, 20, 0]]}>
            <List isText>
              <ListItem>
                <DisplayContent addNode contentKey="1-list-item">
                  How about a trip where you can see half of Europe?
                </DisplayContent>
              </ListItem>
              <ListItem>
                <DisplayContent addNode contentKey="2-list-item">
                  Take away control, see the contrast
                </DisplayContent>
              </ListItem>
              <ListItem>
                <DisplayContent addNode contentKey="3-list-item">
                  Brief time at each location
                </DisplayContent>
              </ListItem>
              <ListItem>
                <DisplayContent addNode contentKey="4-list-item">
                  Time after time with your scratch card at the airport
                </DisplayContent>
              </ListItem>
            </List>
          </Style>
          <Style margin={[[0, 0, 40, 0]]}>
            <Grid
              nrCols={[1, 2]}
              minContent
              colGap={[GridGap.m]}
              rowGap={[GridGap.m]}
            >
              <Col>
                <Button cutOff="left" onClick={this.handleDetailsScroll}>
                  <DisplayContent contentKey="cta-plan-trip" edit={true}>
                    Stel trip samen
                  </DisplayContent>
                </Button>
              </Col>
              <Col>
                <Button type={TYPE.angel} onClick={this.handleInfoScroll}>
                  <DisplayContent contentKey="cta-know-more" edit={true}>
                    Wat moet ik weten
                  </DisplayContent>
                </Button>
              </Col>
            </Grid>
          </Style>
          <Style margin={[[0, 0, 20, 0]]}>
            <div className={'clearfix'} ref={this.setDetailsRef}>
              <div className="pull-left">
                <Button type={TYPE.angel}>
                  {entry.theme === Theme.fly ? (
                    <Icon icon={SRPRS.aeroplane} />
                  ) : null}
                  {entry.theme === Theme.drive ? (
                    <Icon icon={SRPRS.car} />
                  ) : null}
                </Button>
              </div>
              <div className="pull-right padding-t-s">
                <NumberPeople disabled={this.props.theme === Theme.solo} />
              </div>
            </div>
          </Style>
          <PersonModal />
          <Style margin={[[0, 0, 20, 0]]}>
            <ActionList>
              <Airport {...{ airports }} />
              <Days options={inControlOptions} hideTrigger />
              <RoomType {...{ hideTrigger: true }} />
              <FlyExcluded />
            </ActionList>
          </Style>
          <Style margin={[[0, 0, 20, 0]]}>
            <Box fullWidthMobile>
              <Calendar
                actionList
                minDate={new Date(2019, 1, 1)}
                maxDate={new Date(2019, 4, 1)}
                hideTrigger
                showCheapest={true}
                prices={prices}
                loading={loading}
              />
            </Box>
          </Style>
        </Section>
        <FunnelFooter
          nextStepNo={2}
          nextStepLink={getNameWithTheme('extras')}
          nextStepLinkParams={getParamsWithTheme()}
          nextStepName={
            <DisplayContent edit={true} contentKey="extras">
              Extras
            </DisplayContent>
          }
          stickyStop
          nextStepDisabled={isNaN(this.props.total)}
        />
        <GiftcardModal />
        <FlavourBox
          patternImage={patternImage}
          setInfoRef={this.setInfoRef}
          content={entry.page.content}
        />
        <HowItWorks />
        <Section type={SectionType.white}>
          <ListHeader>
            <Button cutOff="left" onClick={this.handleDetailsScroll}>
              <DisplayContent contentKey="boek-direct" edit={true}>
                Boek direct
              </DisplayContent>
            </Button>
          </ListHeader>
        </Section>
        <FAQ />
      </Page>
    )
  }

  private setInfoRef = (ref: HTMLDivElement) => {
    this.infoSection = ref
  }

  private setDetailsRef = (ref: HTMLDivElement) => {
    this.detailsSection = ref
  }

  private handleInfoScroll = () => {
    if (this.infoSection) {
      this.infoSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  private handleDetailsScroll = () => {
    if (this.detailsSection) {
      this.detailsSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }
}

const ConnectedFlavourPage = connect((state: AppState) => ({
  patternImage: state.page.patternImage,
  departureDate: state.funnelOrder.departureDate,
  total: state.funnelOrder.total,
  theme: state.funnelOrder.theme,
}))(FlavourPage)

export default withAirportsAndPrices<EntryProps>(
  ConnectedFlavourPage,
  [QueryKey.month, QueryKey.year],
  true,
)
